module.exports = __webpack_public_path__ + "static/media/DH_01.bbca71f8.jpg";